// Local theme previews use a loopback transport to the real authenticated Worker.
// Production keeps its configured API and normal password/session behavior.
(function () {
  if (!['localhost', '127.0.0.1', '[::1]'].includes(location.hostname)) return;
  var root = document.querySelector('[data-pmg-app]');
  if (!root) return;
  root.setAttribute('data-pmg-worker-url', 'http://127.0.0.1:8790');
  if (localStorage.getItem('pmg_session_token') === 'local-demo-only') {
    localStorage.removeItem('pmg_session_token');
  }
})();
